export const formattedTs = (ts: string) => {
  const date = new Date(ts);
  return new Intl.DateTimeFormat('it-IT', {
    weekday: 'short',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}
